<template>
    <el-drawer title="导出乐迷" 
        :visible.sync="exportVisible" 
        :before-close="closeDialog" 
        class="export-box"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto">
        <div class="drawer-content">
            <el-form :model="exportForm" :rules="rules" ref="exportForm">
                <el-form-item label="导出方式" prop="type" size="medium">
                    <el-select v-model="exportForm.type">
                        <el-option label="导出演出购票乐迷" :value="1"></el-option>
                        <el-option label="导出演出收藏乐迷" :value="2"></el-option>
                        <el-option label="导出艺人乐迷粉丝" :value="3"></el-option>
                        <el-option label="导出场地乐迷粉丝" :value="4"></el-option>
                        <el-option label="导出厂牌乐迷粉丝" :value="5"></el-option>
						<el-option label="导出演出开票登记乐迷" :value="6"></el-option>
						<el-option label="导出演出缺票登记乐迷" :value="7"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="ids" size="medium">
                    <template slot="label">
                        <span>演出ID/用户ID</span>
                        <span class="export-tips">
                            多个ID，用英文逗号分隔
                        </span>
                    </template>
                    <el-input v-model="exportForm.ids" type="textarea" placeholder="请输入ID" maxlength="20000"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="closeDialog">关 闭</el-button>
            <el-button type="primary" @click="submit">开始导出</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {
    type: 1,
    ids: ''
}
export default {
    data(){
        return {
            exportForm: {...defaultData},
            btnLoading: false,
            rules:  {
                type: [{ required: true, message: "请选择导出方式", trigger: 'change' }],
                ids: [{ required: true, message: "至少填写一个ID"}]
            }
        }
    },
    props: {
        exportVisible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        submit(){
            this.$refs['exportForm'].validate(valid=> {
                if(valid){
                    this.btnLoading = true;
                    this.$request({
                        url: '/fans/manger/createExport',
                        method: "POST",
                        data: {...this.exportForm}
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$confirm('由于数据量较大，已生成下载任务，是否跳转查看？', '导出乐迷', {
                                confirmButtonText: '立即查看',
                                cancelButtonText: '稍后再看',
                                type: 'success',
                                center: true,
                                closeOnClickModal: false
                            }).then(() => {
                                this.closeDialog();
                                this.$router.push({path:'/workbench/downloadList'})
                            }).catch(() => {})
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.btnLoading = false;
                    })
                }
            })   
        },
        closeDialog(){
            this.$emit('update:exportVisible', false); 
            this.exportForm = {...defaultData};
            this.$nextTick(()=> {
                this.$refs['exportForm'].clearValidate()
            })
        },
    }
}
</script>

<style lang="scss">
.export-box{
    .export-tips{
        margin-left: 10px;
        font-size: 12px;
        line-height: 12px;
        color: #909399;
    }
}
</style>